import techtalk from "../assets/images/video-thum/Techtalk-nlp-for-accelerated-lending-thumbnail-banner.png";
import mlopsvb from "../assets/images/video-thum/mlopsvb.png";
import awsimmer from "../assets/images/video-thum/aws_immersionday_june_banner.png";
import web2thumb from "../assets/images/video-thum/web2thumb.png";
import webthumb from "../assets/images/video-thum/webthumb.png";

export const RESOURCES_VIDEOS = [
  {
    videos: [
      {
        title: "TechTalk: Natural Language Processing for Accelerated Lending",
        videoLink: "/videos/TechTalk-NLP.mp4",
        thumbnail: techtalk,
        desc: "Watch the video and learn more about Natural Language Processing (NLP) and how NLP-driven technologies are used to streamline and accelerate lending processes.",
      },
      {
        title:
          "AWS Immersion Day: How Amazon Rekognition Accelerates Digital Transformation for Financial Services",
        videoLink: "/videos/AWS-immersion-day-Digital-Transformation.mp4",
        thumbnail: awsimmer,
        desc: "Watch the video and learn more about the basic concepts in computer vision, the capabilities of Amazon Rekognition, and how Idexcel has used Amazon Rekognition to solve some of the industry challenges for better lending.",
      },
      {
        title: "Webinar: Scale Your Machine Learning with MLOps",
        videoLink: "/videos/mlops.mp4",
        thumbnail: mlopsvb,
        desc: "Watch the video to learn more about the best practices of MLOps and how it can help you to streamline your machine learning workflows, reduce costs, and achieve business outcomes faster.",
      },
      {
        title:
          "Webinar: Accelerate and Modernize Redshift Migration with AWS and Idexcel",
        videoLink: "/videos/Redshift-Migration.mp4",
        thumbnail: web2thumb,
        desc: "Watch the video to learn digital transformation initiatives to modernize AWS Redshift within your organization and how Idexcel's migration services help solve data migration challenges to AWS Redshift.",
      },
      {
        title:
          "Webinar: How to Accelerate Data Extraction for Public Sector Organizations",
        videoLink:
          "/videos/How-to-Accelerate-Data-Extraction-for-Public-Sector-Organizations.mp4",
        thumbnail: webthumb,
        desc: "Watch the video and learn more about digital transformation initiatives within public sector organizations and how Idexcel's AIDE helps solve data extraction challenges.",
      },
    ],
  },
];
